import {
  Router,
  schema,
  type RouteNameDynamic,
  type RouteNameStatic,
  type RouteParamsDynamic,
  type RouteParamsStatic,
} from 'next-roots'

import { LOCALE } from '@/legacy-src/constants/locale.constants'

import type { OmitLocale } from '@/src/domains/next-roots/types'

const router = new Router(schema)

// with the way we use next-roots (one active locale at a time),
// we cannot use the `getHref` method directly for foreign locales.
// Check `getLocalizedHrefForLocale` for that use case.
export const getLocalisedHref = <T extends RouteNameStatic | RouteNameDynamic>(
  href: T,
  params?: T extends RouteNameDynamic ? OmitLocale<RouteParamsDynamic<T>> : OmitLocale<RouteParamsStatic>,
): string => router.getHref(href as RouteNameStatic, { locale: LOCALE, ...params })
